import { render, staticRenderFns } from "./EventPaymentConfirm.vue?vue&type=template&id=9cafd968"
import script from "./EventPaymentConfirm.vue?vue&type=script&lang=js"
export * from "./EventPaymentConfirm.vue?vue&type=script&lang=js"
import style0 from "./EventPaymentConfirm.vue?vue&type=style&index=0&id=9cafd968&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports